import { useUiStore } from '@/stores/ui/store';
import { Ref, watch } from 'vue';


export default (items: Ref<any[]>, idUsersPropertyNames: string[] = ['idUser']) => {
  const uiStore = useUiStore();
  
  const loadNotCachedUserAvatars = () => {
    const userIds: string[] = [];
    idUsersPropertyNames.forEach((propertyName) => {
      userIds.push(...(items.value ?? []).filter((x) => x[propertyName]).map((x) => String(x[propertyName])));
    });
    uiStore.cacheUserAvatars(userIds.filter((x) => !!x));
  };

  watch(
    () => items.value,
    () => loadNotCachedUserAvatars()
  );
  loadNotCachedUserAvatars();

  return {};
};
